import { useTranslation } from 'react-i18next';

import './index.css';

const Card = ({ title, property, description, image, goToContact }: { title?: string; property?: string; description?: string; image?: string, goToContact?: () => void }) => {

  const { t } = useTranslation();

  return (
    <div className="gc-card">
      {image &&
        <div className="gc-card-image">
          <img className="gc-card-img" src={image} alt={title || "Card Image"} />
        </div>
      }
      <div className="gc-card-info">
        <div>
          {title && <h3>{title}</h3>}
          {property && <b>{property}</b>}
        </div>
        {(description || goToContact) &&
          <div className='gc-card-description'>
            {description && <p dangerouslySetInnerHTML={{ __html: description }}></p>}
            {goToContact &&
              <div className="gc-card-link" onClick={goToContact}>
                {t('common:buttons.contactUs' as any)}
              </div>
            }
          </div>
        }
      </div>
    </div>
  )
}

export default Card;